export default "__VITE_ASSET__B6TPQuLS__"